/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

function DarkFooter() {
  return (
    <footer className="footer" data-background-color="black">
      <Container>
        <nav>
          <ul>
            <li>
              <a
                href="/index"
                //target="_blank"
              >
                Contact Us:
              </a>
            </li>
            <li>
            (305) 713-9499
            
              
            </li>
            <li>
              
            
              <a
                href="mailto: sgaremodelingcorp@gmail.com"
                target="_blank"
                style={{
                  color: "#add8e6"
                
                }}
              >
                 Email: sgaremodelingcorp@gmail.com
              </a>
            </li>
          </ul>
        </nav>
        <div className="copyright" id="copyright">
          ©Miami, Florida {new Date().getFullYear()}
        </div>
      </Container>
    </footer>
  );
}

export default DarkFooter;
